export const fieldMap = {
  'suggest': 'Suggest',
  'suburb': 'Suburb',
  'address': 'Address',
  'place': 'Place',
  'date': 'DateComp',
  'dob': 'DOB',
  'image-button': 'ImageButton',
  'country': 'Suggest',
  'select': 'Select',
  'checkbox': 'Checkbox',
  'checkboxList': 'CheckboxList',
};
